var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.journal)?_c('div',[_c('app-pattern-journal',{key:_vm.getRandomInt(10),attrs:{"bo":_vm.bo}}),_vm._v(" "),_c('app-footer-journal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }